import { z } from 'zod';
import { SkillToolKeySchema } from './skills.js';
export const LessonStatusSchema = z.enum(['pending', 'active', 'rejected', 'archived']);
export const SkillLessonSchema = z.object({
    id: z.string().uuid(),
    skillId: z.string().uuid(),
    skillName: z.string(),
    toolKey: SkillToolKeySchema,
    title: z.string(),
    errorSample: z.string(),
    lastInputSample: z.unknown().nullable(),
    guidance: z.string(),
    /** LLM 이 만든 초안. 사람이 채택해 guidance 로 옮기기 전까지 별도 칼럼에 보관. */
    suggestedGuidance: z.string().nullable(),
    suggestedAt: z.string().nullable(),
    suggestedModel: z.string().nullable(),
    status: LessonStatusSchema,
    failureCount: z.number().int().nonnegative(),
    firstSeenAt: z.string(),
    lastSeenAt: z.string(),
    reviewedAt: z.string().nullable(),
});
export const SkillLessonListQuerySchema = z.object({
    status: LessonStatusSchema.optional(),
    skillId: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    /** keyset pagination: lastSeenAt ISO 문자열. */
    cursor: z.string().optional(),
});
export const SkillLessonListSchema = z.object({
    lessons: z.array(SkillLessonSchema),
    nextCursor: z.string().nullable(),
});
export const UpdateSkillLessonRequestSchema = z.object({
    title: z.string().min(1).max(120).optional(),
    guidance: z.string().max(600).optional(),
    /** 편집 후 바로 활성화. guidance 가 비면 400. */
    activate: z.boolean().optional(),
});
export const SetSkillLessonStatusRequestSchema = z.object({
    status: LessonStatusSchema,
});
export const SkillLessonPendingCountSchema = z.object({
    count: z.number().int().nonnegative(),
});
/** /suggest 응답 — 갱신된 lesson DTO 그대로. 별도 스키마 alias 두지 않고 SkillLessonSchema 재사용. */
//# sourceMappingURL=skill-lessons.js.map